<template>
  <div class="home content-continer">
    <!-- 最上面项目详情 -->
    <div class="base-content items">
      <div style="margin-bottom:30px;">
        <a class="list-name">{{projectlists.projectName}}</a>
      </div>
      <ul class="list-msg">
        <li>
          <p>CRC人数</p>
          <p>{{projectlists.crcNum}}</p>
        </li>
        <li>
          <p>专业名称</p>
          <p>{{projectlists.specialityName}}</p>
        </li>
        <li>
          <p>负责人</p>
          <p>{{projectlists.managerName}}</p>
        </li>
        <li>
          <p>项目类型</p>
          <p>{{projectlists.phaseDesc}}</p>
        </li>
        <li>
          <p>项目开始时间</p>
          <p>{{projectlists.startDate}}</p>
        </li>
        <li>
          <p>申办方</p>
          <p>{{projectlists.sponsorName}}</p>
        </li>
        <li>
          <p>公司名称</p>
          <p>{{projectlists.smoName}}</p>
        </li>
        <!-- <li>
          <p>公司区域</p>
          <p>{{projectlists.smoProvince}}</p>
        </li>-->
      </ul>
      <p class="remarks">{{projectlists.projectDesc}}</p>
      <div class="search_title">
        <div class="blue">人员信息</div>
        <div class="screen">
          <span>筛选条件</span>
          <span>CRC人员</span>
          <input type="text" style="width:120px;height:30px;border-radius:4px;" v-model="crcName" />
          <span>性别</span>
          <el-select v-model="sex" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <a class="blue-btn refresh right" @click="Cappointlist">
            <i class="el-icon-search"></i>查询
          </a>
        </div>
      </div>
    </div>
    <!-- 人员列表 -->
    <div class="continer-title base-content">
      <div class="blue left">
        CRC人员列表
        <p class="gcheck">共{{total}}人</p>
        <p style="display:inline-block;color:#333;margin-left:5px;">已委派{{projectlists.delegatedNum}}人</p>
      </div>
      <div class="right" v-if="projectlists.crcList!=''">
        <p class="ycheck">已选{{xcheck}}人</p>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
        >全选</el-checkbox>

        <a class="btn blue-btn" @click="Cappointbtn">委派</a>
      </div>
      <div style="clear: both"></div>
    </div>
    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
      <div
        class="base-content person-list"
        v-for="(item,index) in projectlists.crcList"
        :key="index"
      >
        <ul class="list-msg">
          <li>
            <el-checkbox :label="item.id+'*'+item.name" @change="change">&nbsp;</el-checkbox>
          </li>
          <li class="img-src">
            <img :src="imgurl+item.headImg" />
          </li>
          <li>
            <div class="person-name">{{item.name}}</div>
            <ul>
              <li>
                <p>项目数量</p>
                <p>{{item.projectNum?item.projectNum:'0'}}</p>
              </li>
              <li>
                <p>学校</p>
                <p>{{item.schoolName?item.schoolName:'无'}}</p>
              </li>
              <li>
                <p>学历</p>
                <p>{{item.eduLevel?item.eduLevel:'无'}}</p>
              </li>
              <li>
                <p>专业</p>
                <p>{{item.major?item.major:'无'}}</p>
              </li>
              <li>
                <p>备案时间</p>
                <p>{{item.beianTime?item.beianTime:'无'}}</p>
              </li>
            </ul>
          </li>
          <li class="msg-modal blue">
            <a @click="previewMsg(item.id)">查看资料</a>
          </li>
        </ul>
        <img src="../assets/hospital-img/s-no-j.png" v-if="item.delegateState==2" class="d" />
        <img src="../assets/hospital-img/s-y-j.png" v-if="item.delegateState==3" class="d" />
      </div>
    </el-checkbox-group>
    <!-- 全选和委派 -->

    <div v-if="projectlists.crcList==''" class="center" style="margin-top: 50px;">该公司还没有委派CRC</div>
    <!-- 委派弹框 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="430px" center>
      <span>
        委派
        <span class="dhs">
          <span class="blue" v-for="(item,index) in changename" :key="index">
            {{item}}
            <span class="dh">、</span>
          </span>
        </span>
        {{checkedCities.length}}位CRC人员到{{projectlists.hospitalName}}进行{{projectlists.projectName}}研究试验。
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Cappoint">确 定</el-button>
      </span>
    </el-dialog>
    <div class="preview-modal" v-if="peviewstatus">
      <Preview @peviewstatus="closePeview" :childid="childid"></Preview>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { Cappointlist } from "@/request/api";
import { Cappoint } from "@/request/api";
import Preview from "../components/preview";

export default {
  name: "home",
  components: {
    Preview: Preview
  },
  data() {
    return {
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: false,
      checkedGameId: [],
      value: "",
      dialogVisible: false, //委派弹框
      userId: "13",
      projectid: "",
      projectlists: "",
      imgurl: this.Common.imgurl,
      options: [
        {
          value: "1",
          label: "男"
        },
        {
          value: "2",
          label: "女"
        }
      ],
      sex: "",
      changejsons: [],
      changeid: [],
      changename: [],
      peviewstatus: false,
      childid: "",
      crcName: "",
      total: "0",
      xcheck: "0"
    };
  },
  methods: {
    handleCheckAllChange(val) {
      // 若val为真返回cityoptions,否则返回[]
      this.checkedCities = val ? this.checkedGameId : [];
      this.isIndeterminate = false;
      this.change();
      this.xcheck = this.checkedCities.length;
    },
    handleCheckedCitiesChange(value) {
      // this.changeid=value.split("*");
      let checkedCount = value.length;
      // alert(checkedCount);
      this.xcheck = checkedCount;
      this.checkAll = checkedCount === this.checkedGameId.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkedGameId.length;
    },
    // 查看资料
    previewMsg(id) {
      this.childid = id;
      this.peviewstatus = true;
    },
    closePeview(data) {
      this.peviewstatus = data;
    },
    change() {
      this.changejsons = [];
      for (let i = 0; i < this.checkedCities.length; i++) {
        this.changejsons.push(this.checkedCities[i].split("*"));
      }
      this.changeid = [];
      for (let i = 0; i < this.changejsons.length; i++) {
        this.changeid.push(this.changejsons[i][0]);
      }
      console.log(this.changeid);
      this.changename = [];
      for (let i = 0; i < this.changejsons.length; i++) {
        this.changename.push(this.changejsons[i][1]);
      }
      console.log(this.changename);
    },
    // 委派
    Cappointbtn() {
      if (this.checkedCities.length > 0) {
        this.dialogVisible = true;
      } else {
        this.$message("请选择要委派的人");
      }
    },
    //委派列表
    Cappointlist() {
      let data = {
        crcName: this.crcName,
        projectId: this.projectid,
        userId: this.userId,
        sex:this.sex
      };
      Cappointlist(data)
        .then(res => {
          this.projectlists = res.data.data;
          console.log(this.projectlists);
          this.total = this.projectlists.crcList.length;
          for (let i = 0; i < this.projectlists.crcList.length; i++) {
            this.checkedGameId.push(
              this.projectlists.crcList[i].id +
                "*" +
                this.projectlists.crcList[i].name
            );
            // this.multipleSelection = this.checkedGameId
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 确认委派
    Cappoint() {
      let ids = this.changeid.join(",");
      let data = {
        crcIds: ids,
        projectId: this.projectid,
        userId: this.userId
      };
      Cappoint(data)
        .then(res => {
          if (res.data.code == "00000") {
            this.dialogVisible = false;
            this.$message({
              message: "委派成功",
              type: "success"
            });
            this.Cappointlist();
            this.checkedCities = [];
            this.checkAll = false;
          } else {
            this.$message(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.projectid = this.$route.params.projectId;
    this.userId = Cookies.get("userid");
  },
  mounted() {
    // crc人员列表
    this.Cappointlist();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.items {
  margin-top: 20px;
  margin-bottom: 20px;
}

.items .list-name {
  font-size: 18px;
  color: #4d4d4d;
}

.items li {
  display: inline-block;
  margin-right: 30px;
}

.item li:last-child {
  margin-right: 0px;
}

.list-msg li p:first-child {
  color: #999999;
  /* font-weight:bold; */
  font-size: 14px;
}

.list-msg li p:last-child {
  color: #666666;
  margin-top: 10px;
  font-size: 16px;
  /* font-weight:bold; */
}

.remarks {
  width: 100%;
  /* height: 40px; */
  line-height: 40px;
  background: rgba(245, 245, 245, 1);
  color: #999999;
  font-size: 14px;
  margin-top: 26px;
  padding-left: 5px;
}

.screen >>> .el-input__inner {
  height: 30px !important;
  line-height: 30px;
  width: 100px;
}

.screen >>> .el-input__icon {
  line-height: 30px;
}

.screen span:first-child {
  color: #999;
}
.screen span:first-child {
  margin-left: 0px;
}
.screen span {
  margin-left: 30px;
  color: #666666;
  font-size: 14px;
}

.refresh {
  display: inline-block;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-left: 20px;
  border-radius: 2px;
  cursor: pointer;
}
.dhs > span:last-child > .dh {
  display: none;
}
.search_title .blue {
  font-size: 16px;
  margin-bottom: 20px;
}
.search_title {
  margin-top: 30px;
}
.continer-title {
  line-height: 80px;
  padding: 0px 32px;
}
.gcheck {
  display: inline-block;
  width: 60px;
  height: 26px;
  background: rgba(224, 238, 254, 1);
  border-radius: 2px;
  color: rgba(54, 114, 191, 1);
  line-height: 26px;
  text-align: center;
  margin-left: 20px;
}
.ycheck {
  display: inline-block;
  width: 73px;
  height: 26px;
  background: rgba(252, 227, 198, 1);
  border-radius: 2px;
  color: rgba(191, 100, 26, 1);
  line-height: 26px;
  text-align: center;
  margin-right: 40px;
}
</style>


// WEBPACK FOOTER //
// src/company/appoint.vue